<div class="container">
    <app-list entityName="ActivoFijo" module="MovimientoBienes"
              customTitle="Activos Dados de Baja"
              [url]="PAGES.MOVEMENT_ASSETS_UP"
              [noActions]="true"
              [dataEntity]="{enableAdd: false}"
              group="down"
              [defaultQuery]="[{column: 'cencos', value: ''}, {column: 'dateDown', value: true}]">
    </app-list>
</div>
